import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-25 border-0 rounded-0 bg-white letter-spacing lead-info-box rounded-0"
}
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30" }
const _hoisted_3 = { class: "profile-info d-flex flex-column flex-sm-row align-items-baseline justify-content-between gap-3" }
const _hoisted_4 = {
  key: 0,
  class: "m-0"
}
const _hoisted_5 = { class: "text-black fw-medium mb-0 h2" }
const _hoisted_6 = {
  class: "info px-2 mb-0 list-unstyled row",
  id: "patient-anagraph-info"
}
const _hoisted_7 = { class: "position-relative col-lg-6 col-xxl-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "icon text-success rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph ph-envelope-simple" })
], -1 /* HOISTED */)
const _hoisted_9 = { class: "d-block text-black mb-5 fw-semibold" }
const _hoisted_10 = ["href"]
const _hoisted_11 = {
  key: 0,
  class: "position-relative col-lg-6 col-xxl-4"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "icon text-warning-light rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph ph-phone" })
], -1 /* HOISTED */)
const _hoisted_13 = { class: "d-block text-black mb-5 fw-semibold" }
const _hoisted_14 = ["href"]
const _hoisted_15 = {
  key: 1,
  class: "position-relative col-lg-6 col-xxl-4"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "icon text-info rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph ph-calendar-blank" })
], -1 /* HOISTED */)
const _hoisted_17 = { class: "d-block text-black mb-5 fw-semibold" }
const _hoisted_18 = { class: "d-inline-block fs-md-15 fs-lg-16 text-muted" }
const _hoisted_19 = {
  key: 2,
  class: "position-relative col-lg-6 col-xxl-4"
}
const _hoisted_20 = { class: "icon text-danger rounded-circle text-center" }
const _hoisted_21 = { class: "d-block text-black mb-5 fw-semibold" }
const _hoisted_22 = { class: "d-inline-block fs-md-15 fs-lg-16 text-muted" }
const _hoisted_23 = {
  key: 3,
  class: "position-relative col-lg-6 col-xxl-4"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "icon text-primary rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph ph-first-aid" })
], -1 /* HOISTED */)
const _hoisted_25 = { class: "d-block text-black mb-5 fw-semibold" }
const _hoisted_26 = { class: "d-inline-block fs-md-15 fs-lg-16 text-muted" }
const _hoisted_27 = {
  key: 4,
  class: "position-relative col-lg-6 col-xxl-4"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "icon text-muted rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph ph-map-pin" })
], -1 /* HOISTED */)
const _hoisted_29 = { class: "d-block text-black mb-5 fw-semibold" }
const _hoisted_30 = { class: "d-inline-block fs-md-15 fs-lg-16 text-muted" }
const _hoisted_31 = {
  key: 0,
  class: "d-flex flex-column"
}
const _hoisted_32 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_33 = { class: "values d-flex flex-column gap-1" }
const _hoisted_34 = { class: "d-flex align-items-baseline flex-column" }
const _hoisted_35 = { class: "fs-md-15 fs-lg-16 text-muted" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_37 = { class: "d-flex justify-content-end mb-10 mt-10" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("i", { class: "ph-duotone ph-user-list text-black fs-16" }, null, -1 /* HOISTED */)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("i", { class: "ph-duotone ph-pencil text-black fs-16" }, null, -1 /* HOISTED */)
const _hoisted_40 = { class: "mx-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PatientCancellationWarning = _resolveComponent("PatientCancellationWarning")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DownloadPatientData = _resolveComponent("DownloadPatientData")!

  return (_ctx.patient)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.patient.right_to_erasure_requested_at != undefined)
            ? (_openBlock(), _createBlock(_component_PatientCancellationWarning, {
                key: 0,
                patient: _ctx.patient
              }, null, 8 /* PROPS */, ["patient"]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_3, [
            (_ctx.minimal)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.patient.firstname) + " " + _toDisplayString(_ctx.patient.lastname), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" <span class=\"d-block text-dark-emphasis mb-0 small\">\n          {{ patient.id }}\n        </span> ")
          ]),
          (!_ctx.minimal)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createCommentVNode(" <div class=\"border-top mt-15 mb-15\"></div> "),
                _createElementVNode("ul", _hoisted_6, [
                  _createElementVNode("li", _hoisted_7, [
                    _hoisted_8,
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('form.email.label')), 1 /* TEXT */),
                    _createElementVNode("a", {
                      href: `mailto:${_ctx.email}`,
                      class: "d-inline-block fs-md-15 fs-lg-16 text-primary text-decoration-none"
                    }, _toDisplayString(_ctx.email), 9 /* TEXT, PROPS */, _hoisted_10)
                  ]),
                  ((_ctx.patient.self_registration ?? false) === false)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
                        _hoisted_12,
                        _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('form.phone.label')), 1 /* TEXT */),
                        _createElementVNode("a", {
                          href: `tel:${_ctx.phone}`,
                          class: "d-inline-block fs-md-15 fs-lg-16 text-primary text-decoration-none"
                        }, _toDisplayString(_ctx.phone), 9 /* TEXT, PROPS */, _hoisted_14)
                      ]))
                    : _createCommentVNode("v-if", true),
                  ((_ctx.patient.self_registration ?? false) === false)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_15, [
                        _hoisted_16,
                        _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('form.birth_date.label')), 1 /* TEXT */),
                        _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.patient.birthdate), 1 /* TEXT */)
                      ]))
                    : _createCommentVNode("v-if", true),
                  ((_ctx.patient.self_registration ?? false) == false)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("i", {
                            class: _normalizeClass('ph ph-gender-' + `${_ctx.getGenderIcon(_ctx.patient.sex)}`)
                          }, null, 2 /* CLASS */)
                        ]),
                        _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t('form.gender.label')), 1 /* TEXT */),
                        _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.patient.sex != null ? _ctx.$t(`form.gender.${_ctx.patient.sex}`) : ''), 1 /* TEXT */)
                      ]))
                    : _createCommentVNode("v-if", true),
                  (!((_ctx.center(_ctx.patient.center_id)?.is_custom_center ?? false) == true || (_ctx.patient.self_registration ?? false) == true))
                    ? (_openBlock(), _createElementBlock("li", _hoisted_23, [
                        _hoisted_24,
                        _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t('form.center_id.label')), 1 /* TEXT */),
                        _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.center(_ctx.patient.center_id)?.name ?? _ctx.patient.center_id), 1 /* TEXT */)
                      ]))
                    : _createCommentVNode("v-if", true),
                  ((_ctx.patient.self_registration ?? false) == false)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_27, [
                        _hoisted_28,
                        _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t('form.address.label')), 1 /* TEXT */),
                        _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.patient.address) + ", " + _toDisplayString(_ctx.patient.city) + ", " + _toDisplayString(_ctx.patient.region) + " - " + _toDisplayString(_ctx.patient.zipcode) + " - " + _toDisplayString(_ctx.patient.country), 1 /* TEXT */)
                      ]))
                    : _createCommentVNode("v-if", true)
                ]),
                _createCommentVNode(" EXTRA DEFINITIONS "),
                (_ctx.showExtraDefinitions && _ctx.definitions != undefined)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_31, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.definitions, (definition) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: definition.dataextra_schema_name
                        }, [
                          (!_ctx.hideExtraDefinitionBlock(definition))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                _createElementVNode("h5", null, _toDisplayString(definition.dataextra_scheme.description), 1 /* TEXT */),
                                _createElementVNode("div", _hoisted_33, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(definition.dataextra_scheme.definitions, (value, key) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: key,
                                      class: "d-flex flex-column"
                                    }, [
                                      (!_ctx.hideAnswer(definition, value.name))
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createElementVNode("div", _hoisted_34, [
                                              _createElementVNode("strong", null, _toDisplayString(_ctx.getDefinition(definition, value.name)?.description), 1 /* TEXT */),
                                              _createCommentVNode("<span class=\"d-inline fs-12 text-muted fw-normal d-block\">{{ getDefinition(definition, value.name)?.description }}</span>")
                                            ]),
                                            _createElementVNode("span", _hoisted_35, [
                                              (_ctx.getDefinition(definition, value.name)?.type === 'number' || _ctx.getDefinition(definition, value.name)?.type === 'text' || _ctx.getDefinition(definition, value.name)?.type === 'textarea' || _ctx.getDefinition(definition, value.name)?.type === 'range')
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                    _createTextVNode(_toDisplayString(definition.dataextra_value[value.name]), 1 /* TEXT */)
                                                  ], 64 /* STABLE_FRAGMENT */))
                                                : (_ctx.getDefinition(definition, value.name)?.type === 'select' || _ctx.getDefinition(definition, value.name)?.type === 'radio' || _ctx.getDefinition(definition, value.name)?.type === 'checkbox')
                                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                      _createTextVNode(_toDisplayString(_ctx.getDefinition(definition, value.name)?.options?.find((option) => option.value ===
                          definition.dataextra_value[value.name])?.text), 1 /* TEXT */)
                                                    ], 64 /* STABLE_FRAGMENT */))
                                                  : (_ctx.getDefinition(definition, value.name)?.type === 'date')
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                        _createTextVNode(_toDisplayString(_ctx.YYYYMMDD(definition.dataextra_value[value.name] as string)), 1 /* TEXT */)
                                                      ], 64 /* STABLE_FRAGMENT */))
                                                    : (_ctx.getDefinition(definition, value.name)?.type === 'select-text')
                                                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList((definition.dataextra_value[value.name] as ExtraResponseTextSelect), (text, option) => {
                                                          return (_openBlock(), _createElementBlock(_Fragment, { key: option }, [
                                                            _createElementVNode("strong", null, _toDisplayString(_ctx.getDefinition(definition, value.name)?.options?.find((choice) => choice.value ===
                            option)?.text), 1 /* TEXT */),
                                                            _createTextVNode(": " + _toDisplayString(text), 1 /* TEXT */),
                                                            _hoisted_36
                                                          ], 64 /* STABLE_FRAGMENT */))
                                                        }), 128 /* KEYED_FRAGMENT */))
                                                      : _createCommentVNode("v-if", true)
                                            ])
                                          ], 64 /* STABLE_FRAGMENT */))
                                        : _createCommentVNode("v-if", true)
                                    ]))
                                  }), 128 /* KEYED_FRAGMENT */)),
                                  _createCommentVNode("<div v-for=\"(value, key) in definition.dataextra_value\" :key=\"key\" class=\"d-flex flex-column\">\n                  <template v-if=\"!hideExtraValue(getDefinition(definition, key)!, value)\">\n                    <strong>{{ getDefinition(definition, key)?.description }}</strong>\n                    <span class=\"fs-md-15 fs-lg-16 text-muted\">\n                      <template\n                        v-if=\"getDefinition(definition, key)?.type === 'number' || getDefinition(definition, key)?.type === 'text' || getDefinition(definition, key)?.type === 'textarea' || getDefinition(definition, key)?.type === 'range'\">\n                        {{ value }}\n                      </template>\n                      <template\n                        v-else-if=\"getDefinition(definition, key)?.type === 'select' || getDefinition(definition, key)?.type === 'radio' || getDefinition(definition, key)?.type === 'checkbox'\">\n                        {{ getDefinition(definition, key)?.options?.find((option) => option.value === value)?.text }}\n                      </template>\n                      <template v-else-if=\"getDefinition(definition, key)?.type === 'date'\">\n                        {{ YYYYMMDD(value as string) }}\n                      </template>\n                      <template v-else-if=\"getDefinition(definition, key)?.type === 'select-text'\">\n                        <template v-for=\"(text, option) in (value as ExtraResponseTextSelect)\" :key=\"option\">\n                          <strong>{{ getDefinition(definition, key)?.options?.find((choice) => choice.value ===\n                            option)?.text }}</strong>: {{ text }}<br>\n                        </template>\n                      </template>\n                    </span>\n                  </template>\n                </div>")
                                ])
                              ]))
                            : _createCommentVNode("v-if", true)
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", _hoisted_37, [
                  _createCommentVNode(" <h5 class=\"fw-medium text-black-emphasis mb-0\">{{ $t('form.section.personal_information') }}</h5> "),
                  _createCommentVNode(" <span></span> "),
                  (_ctx.updateEnabled)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: { path: `/patient/${_ctx.patient.id}/caregivers` },
                        class: "d-inline-flex text-decoration-none lh-1 text-muted fw-medium gap-2 align-items-end mx-1"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_38,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('page.caregivers')) + " " + _toDisplayString(_ctx.caregivers.length !== 0 ? `[${_ctx.caregivers.length}]` : ''), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["to"]))
                    : _createCommentVNode("v-if", true),
                  (_ctx.updateEnabled)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 1,
                        to: { path: `/patient/${_ctx.patient.id}/edit` },
                        class: "d-inline-flex text-decoration-none lh-1 text-muted fw-medium gap-2 align-items-end mx-1"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_39,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('cta.edit')), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["to"]))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("div", _hoisted_40, [
                    (_ctx.patient.id != null)
                      ? (_openBlock(), _createBlock(_component_DownloadPatientData, {
                          key: 0,
                          patient_id: _ctx.patient.id!
                        }, null, 8 /* PROPS */, ["patient_id"]))
                      : _createCommentVNode("v-if", true)
                  ])
                ])
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true)
        ])
      ]))
    : _createCommentVNode("v-if", true)
}